// extracted by mini-css-extract-plugin
module.exports = {"HeroSlider":"styles_HeroSlider__RJ1Hb","item":"styles_item__gJf6i","hideOnSmallScreen":"styles_hideOnSmallScreen__cbslk","hideOnLargeScreen":"styles_hideOnLargeScreen__Vl4yA"};